import type { ToolMeta } from "../types";

export const toolMeta: ToolMeta = {
  slug: "color-picker",
  title: "Color Picker",
  pageHeading: "Color Picker From Image",
  description:
    "Get a HEX code from an image, inspect nearby pixels with a zoomed picker, and copy HEX, RGB, or HSL color values.",
  seoTitle: "Color Picker From Image: Get HEX, RGB & HSL",
  seoDescription:
    "Upload a photo, logo, or screenshot and click any pixel to get its exact HEX, RGB, and HSL color code with a zoomed image color picker.",
  featureList: [
    "Pixel-level image color sampling",
    "Zoomed color magnifier",
    "HEX, RGB, and HSL color values",
    "Recent color history",
    "One-click color copying",
    "Browser-only image processing",
  ],
  category: "Design",
} satisfies ToolMeta;
